import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "flex-fill" }
const _hoisted_3 = {
  key: 0,
  class: "time"
}


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CoreUiChatHistorySystemMessage"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    utc: { type: Boolean },
    hasBackgroundImage: { type: Boolean }
  },
  setup(__props: any) {


let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
            'system-info-message-container': true,
            'pr-0': !__props.hasBackgroundImage
        })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.$slots.time)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "pl-1 pr-1" }, "·", -1)),
            _renderSlot(_ctx.$slots, "time")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})